<template>
  <v-container fluid>
    <PageHeading
      text="Категории блога"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-blog-category-new'
          }"
        >
          <v-icon
            class="mr-2"
            small
          >
            mdi-plus
          </v-icon>
          Создать категорию блога
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridBlogCategories ref="grid"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridBlogCategories from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  name: 'PageBlogCategories',
  components: {
    PageHeading,
    GridBlogCategories
  },
  metaInfo () {
    return {
      title: 'Категории блога'
    }
  },
  mixins: [gridPageInterface]
}
</script>
